import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=a308b432&"
import script from "./Checkout.ts?vue&type=script&lang=ts&"
export * from "./Checkout.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports